export default __webpack_public_path__ + "static/4-63c57b1687749b408422bf64d041831e.jpeg";